import { render } from 'react-dom';
import { App } from './components/App/App';
import './index.css'

render(
  <App />,
  document.getElementById('root')
);
